"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _Browser = require('./Browser');

var _Browser2 = _interopRequireDefault(_Browser);

/**
* Model it's a base object class.
* As abstract class, Model is awarness of Browser class and use it to recover data and build entities.
* As an object, Model provides a common methods and structure for API entities: Artists, Tracks, Albums and Playlists
*/

var Model = (function () {
    /**
    * Builds the object based on json data retrieved by endpoint.
    * @param {object} data Endpoint json parsed.
    * @constructor
    */

    function Model(data) {
        _classCallCheck(this, Model);

        /**
        * Flag if model is a simplified object or not.
        * @type {boolean}
        * @see https://developer.spotify.com/web-api/endpoint-reference/
        */
        this.simplified = true;

        /**
        * Data object as it is received from api.
        * @var {object} Endpoint json parsed
        */
        this.rawData = data;

        this._massAssign(data);
    }

    /**
    * Mass assign attributes. Excludes attributes marked as NOT FILLABLE
    * @param {object} data The json parsed endpoint response.
    */

    _createClass(Model, [{
        key: '_massAssign',
        value: function _massAssign(data) {
            var notFillable = this.constructor._getNotFillable() || [];
            for (var el in data) {
                if (notFillable.indexOf(el) === -1 && typeof this[el] != 'function') {
                    this[el] = data[el];
                }
            }
        }

        /**
        * Returns the type of the object.
        *     Used to find the root element intro json endpoint response.
        * @return {string}
        */
    }, {
        key: '_getUserId',
        value: function _getUserId() {
            return false;
        }

        /**
        * Finds an entity by its Spotify ID, calling Browser.get
        * @param {string} id Spotify ID.
        * @return {Promise}
        */
    }, {
        key: 'get',

        /**
        * Ideally this method will load additional information of the entity.
        * Eventually, a partial load is performed. Check Spotify API simplified and full objects.
        * IE: Track.find() will return a track entity with partial album data.
        */
        value: function get() {
            var _this = this;

            var browser = new _Browser2['default']({
                id: this.id,
                factory: this.constructor
            });
            return browser.get().then(function (object) {
                //parasites the returned object to update current one
                _this._massAssign(object.rawData);
                _this.rawData = object.rawData;
                _this.simplified = false;
                return _this;
            });
        }
    }, {
        key: 'apply',
        value: function apply(query_type, payload) {
            var _this2 = this;

            var browser = new _Browser2['default']({
                id: this.id || null,
                query_type: query_type,
                user_id: this._getUserId()
            });

            return browser.send(payload).then(function (object) {
                //parasites the returned object to update current one
                _this2._massAssign(object);
                _this2.rawData = object;
                //this.simplified = false;
                return _this2;
            });
        }
    }], [{
        key: '_getType',
        value: function _getType() {
            return '';
        }
    }, {
        key: 'find',
        value: function find(id) {
            var browser = new _Browser2['default']({ id: id, factory: this });
            return browser.get();
        }

        /**
        * Initializes a conditional query with the given parameter.
        * @param {string|object} condition A string to find by q parameter, or an object with search config.
        * @return {Browser}
        */
    }, {
        key: 'where',
        value: function where(params) {
            var searcher = undefined;
            switch (typeof params) {
                case 'object':
                    searcher = new _Browser2['default'](params);
                    break;
                case 'string':
                default:
                    searcher = new _Browser2['default']();
                    searcher.q = escape(params);
                    break;
            }
            searcher.factory = this;
            return searcher;
        }
    }]);

    return Model;
})();

exports['default'] = Model;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/classes/Model.js
 ** module id = 51
 ** module chunks = 0
 **/